import {
  List as ImmutableList,
} from 'immutable';

import {
  createImmutableMapFromObject,
} from '../../common/collection/collectionUtils';

import Facet from '../../views/filter/facet/Facet';
import Filter from '../../modules/filter/Filter';

function facetDeserializer(data) {
  return Facet.fromPojo({
    ...data,
    filterList: ImmutableList(data.filterList),
    visibleFilterList: ImmutableList(data.visibleFilterList),
    childFilterList: ImmutableList(data.childFilterList),
    siblingFilterList: ImmutableList(data.siblingFilterList),
  });
}

function filtersByFacetMapDeserializers(data) {
  return data && createImmutableMapFromObject(data, {
    transformer: (facetMap, facetId, facetDictionary) => {
      return facetMap.set(facetId,
        createImmutableMapFromObject(
          facetDictionary[facetId],
          {
            transformer: (filterMap, filterId, selectedFiltersDictionary) => {
              return filterMap.set(
                filterId,
                Filter.fromPojo(selectedFiltersDictionary[filterId])
              );
            },
          }
        )
      );
    },
  }, true);
}

const filterDeserializers = {
  facetMap(data) {
    return data && createImmutableMapFromObject(data, {
      transformer: (map, key, obj) => {
        return map.set(key, facetDeserializer(obj[key]));
      },
    }, true);
  },

  selectedFiltersByFacetMap(data) {
    return filtersByFacetMapDeserializers(data);
  },

  visibleSelectedFiltersByFacetMap(data) {
    return filtersByFacetMapDeserializers(data)
  },

  categoryFacet(data) {
    return data && facetDeserializer(data);
  },

  activeFacet(data) {
    return data && facetDeserializer(data);
  },

  previouslySelectedPriceFiltersMap(data) {
    return createImmutableMapFromObject(data);
  },
};

export default filterDeserializers;
